import { useQuery } from '@tanstack/react-query';
import { useApi, useAuth } from '../../hooks';
import { useParams } from 'react-router-dom';
import { EliminationBlockData } from 'models/eliminationBlockData';

type Props = {
  eliminationOrUserBlockId?: string;
  enabled?: boolean;
};

export const useElimination = ({
  eliminationOrUserBlockId,
  enabled = true,
}: Props) => {
  const { patient: userId } = useParams();
  const { api } = useApi();
  const { isAuthenticated, loading, userToken } = useAuth();

  const fetchElimination = async (): Promise<EliminationBlockData> => {
    return await api({
      route: `/private/dashboard/user/${userId}/elimination/${eliminationOrUserBlockId}`,
      token: userToken,
    });
  };

  const { data, isLoading, isError } = useQuery<EliminationBlockData, Error>({
    queryKey: ['elimination', userToken, userId, eliminationOrUserBlockId],
    queryFn: fetchElimination,
    enabled:
      enabled &&
      isAuthenticated &&
      !loading &&
      !!userToken &&
      !!userId &&
      !!eliminationOrUserBlockId,
    refetchOnWindowFocus: false,
  });

  return {
    elimination: data ?? null,
    isLoading,
    isError,
  };
};
